import React from "react";
import { useTranslation } from "react-i18next";
import SectionHead from "./ui/SectionHead";
import featureImg from "../image/Picture3-1.jpg";

const FEATURES = ["mobile", "health", "supply", "climate"];

export function MainFeature() {
  const { t } = useTranslation();

  return (
    <section className="section bg-agri-paper">
      <div className="container-x">
        <SectionHead
          kicker={t("design.mainFeature.badge")}
          title={t("design.mainFeature.title")}
        >
          {t("design.mainFeature.desc")}
        </SectionHead>

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          {/* Portrait crop with a captioned foot — a plate, not a hero banner */}
          <figure className="relative overflow-hidden bg-agri-forestDeep lg:col-span-5">
            <img
              src={featureImg}
              alt="An agricultural extension officer and a farmer reading a diagnosis from a tablet beside a young tomato crop"
              loading="lazy"
              className="h-[24rem] w-full object-cover sm:h-[32rem] lg:h-[36rem]"
            />
            <div
              aria-hidden="true"
              className="absolute inset-x-0 bottom-0 h-1/3 photo-scrim"
            />
            <figcaption className="absolute inset-x-0 bottom-0 p-6">
              <p className="kicker-light">
                {t("design.mainFeature.visualLabel")}
              </p>
              <p className="mt-2 max-w-xs text-[0.9375rem] leading-snug text-white">
                {t("design.mainFeature.visualCaption")}
              </p>
            </figcaption>
          </figure>

          {/* Numbered capability register, divided by hairlines */}
          <dl className="lg:col-span-7 lg:pl-4">
            {FEATURES.map((key, i) => (
              <div
                key={key}
                className="group grid grid-cols-[3rem_1fr] gap-x-4 border-t border-agri-rule py-7 first:border-t-0 first:pt-0 sm:grid-cols-[4rem_1fr] sm:gap-x-6 sm:py-8"
              >
                <span className="pt-1 font-mono text-xs font-medium tabular-nums text-agri-clay">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <dt className="font-display text-[1.1875rem] font-semibold leading-snug tracking-[-0.015em] text-agri-ink sm:text-[1.3125rem]">
                    {t(`design.mainFeature.cards.${key}.title`)}
                  </dt>
                  <dd className="mt-2.5 max-w-measure text-[0.9375rem] leading-[1.7] text-agri-ink80">
                    {t(`design.mainFeature.cards.${key}.desc`)}
                  </dd>
                </div>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}

export default MainFeature;
